import 'es6-promise/auto'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import Vuex from 'vuex'
import 'whatwg-fetch'
import './sass/main.scss'
import VeeValidate from 'vee-validate'
import VueTextareaAutosize from 'vue-textarea-autosize'
import './toasts'
import i18n from './i18n'
import VueCookies from 'vue-cookies'

import axios from 'axios'
import VueAxios from 'vue-axios'
import './directives/mentionify'
import VTooltip from 'v-tooltip'
import { decodeHTML, sanitizeHTML } from './filters/decodeHtml'

axios.defaults.withCredentials = true
axios.interceptors.response.use(response => response, async error => {
  if (error.response.status === 401) {
    Vue.toasted.global.logIn({
      message: i18n.tc('error.sessionExpired.reason'),
      actionText: i18n.tc('error.sessionExpired.action'),
      onClick: () => {
        store.dispatch('redirectToAuthWorkflow')
      }
    })
  }
  return Promise.reject(error)
})

Vue.use(VueAxios, axios)

Vue.use(VueTextareaAutosize)
Vue.use(Vuex)
Vue.use(VueCookies)
Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'ok',
    invalid: 'error'
  }
})
Vue.use(VTooltip)
Vue.config.productionTip = false

Vue.filter('decodeHTML', decodeHTML)
Vue.filter('sanitizeHTML', sanitizeHTML)
// Register utility functions globally
Vue.prototype.$decodeHTML = decodeHTML
Vue.prototype.$sanitizeHTML = sanitizeHTML

const pathAllowswithoutDecode = [
  // gives url to be redirected for login
  '/auth/auth-redirect-url',
  // callback from external authent
  '/auth/login/callback',
  '/auth/check-authent',
  // used for local testing login
  '/auth/fake',
  '/auth',
  '/health',
  '/'
]

// Add a response interceptor
axios.interceptors.response.use(
  response => {
    const requestPath = response.config.url

    if (!pathAllowswithoutDecode.includes(requestPath)) {
      response.data = decodeHTML(response.data)
    }

    return response
  },
  error => {
    return Promise.reject(error)
  }
)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    // Initialize Piano Analytics
    this.$store.commit('setPianoAnalytics')
  }
}).$mount('#app')
